(function () {
  function money(value) {
    if (!Number.isFinite(value)) return '$0';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(value);
  }

  function percentage(value) {
    if (!Number.isFinite(value)) return '0%';
    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 1
    }).format(value) + '%';
  }

  function hours(value) {
    if (!Number.isFinite(value)) return '0 hours';
    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 1
    }).format(value) + ' hours';
  }

  function boundedValue(form, name, minimum, maximum) {
    var field = form.elements[name];
    var value = field ? Number(field.value) : 0;
    if (!Number.isFinite(value)) value = 0;
    if (Number.isFinite(minimum)) value = Math.max(minimum, value);
    if (Number.isFinite(maximum)) value = Math.min(maximum, value);
    return value;
  }

  function optionalBoundedValue(form, name, minimum, maximum, fallback) {
    var field = form.elements[name];
    if (!field || String(field.value).trim() === '') return fallback;
    return boundedValue(form, name, minimum, maximum);
  }

  function setResult(form, name, value) {
    var result = form.querySelector('[data-result="' + name + '"]');
    if (result) result.textContent = value;
  }

  function replaceTokens(template, replacements) {
    var text = template || '';
    Object.keys(replacements || {}).forEach(function (key) {
      text = text.replace('[' + key + ']', replacements[key]);
    });
    return text;
  }

  function calculatorEventPayload(form, additions) {
    var payload = {
      calculator_version: form.dataset.calculatorVersion || '3.0',
      pay_basis: form.elements.pay_basis ? form.elements.pay_basis.value : 'unknown',
      advanced_opened: form.hasAttribute('data-advanced-opened')
    };
    Object.keys(additions || {}).forEach(function (key) {
      payload[key] = additions[key];
    });
    return payload;
  }

  function analyticsProcessingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      var allowed = privacy && privacy.value && privacy.value.allowedProcessing;
      return !allowed || allowed.analytics !== false;
    } catch (error) {
      return true;
    }
  }

  function publishCalculatorEvent(form, eventName, additions) {
    if (!analyticsProcessingAllowed()) return;
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    try {
      var published = analytics.publish(
        'morrow_mama:' + eventName,
        calculatorEventPayload(form, additions)
      );
      if (published && typeof published.catch === 'function') published.catch(function () {});
    } catch (error) {
    }
  }

  function publishCalculatorEventOnce(form, eventName, additions) {
    var marker = 'data-tracked-' + eventName.replace(/_/g, '-');
    if (form.hasAttribute(marker)) return;
    form.setAttribute(marker, 'true');
    publishCalculatorEvent(form, eventName, additions);
  }

  function setCalculatorState(form, calculated) {
    form.dataset.calculated = calculated ? 'true' : 'false';
    form.querySelectorAll('[data-calculator-results]').forEach(function (section) {
      section.hidden = !calculated;
    });
    var emptyState = form.querySelector('[data-calculator-empty]');
    if (emptyState) emptyState.hidden = calculated;
  }

  function syncPayMode(form) {
    var modeField = form.elements.pay_basis;
    var mode = modeField ? modeField.value : 'salary';
    form.querySelectorAll('[data-pay-group], [data-pay-modes]').forEach(function (group) {
      var modes = group.dataset.payModes
        ? group.dataset.payModes.split(/\s+/)
        : [group.dataset.payGroup];
      var isActive = modes.indexOf(mode) !== -1;
      group.hidden = !isActive;
      group.querySelectorAll('input, select').forEach(function (field) {
        field.disabled = !isActive;
        if (field.hasAttribute('data-required-when-active')) field.required = isActive;
      });
    });
  }

  function getInputs(form) {
    var payBasis = form.elements.pay_basis ? form.elements.pay_basis.value : 'salary';
    var paidWeeks = boundedValue(form, 'paid_weeks', 1, 52);
    var basePay = 0;
    if (payBasis === 'hourly') {
      basePay = boundedValue(form, 'hourly_rate', 0, Infinity)
        * boundedValue(form, 'hours_week', 0, 100)
        * paidWeeks;
    } else if (payBasis === 'salary') {
      basePay = boundedValue(form, 'annual_salary', 0, Infinity);
    }
    var grossAnnual = payBasis === 'monthly'
      ? 0
      : basePay + boundedValue(form, 'annual_bonus', 0, Infinity);
    var takeHomeRate = boundedValue(form, 'take_home_percent', 0, 100) / 100;
    var takeHomeAnnual = payBasis === 'monthly'
      ? boundedValue(form, 'take_home_monthly', 0, Infinity) * 12
      : grossAnnual * takeHomeRate;
    var childcareMonthly = boundedValue(form, 'childcare_monthly', 0, Infinity);
    var onsiteDays = boundedValue(form, 'onsite_days', 0, 7);

    return {
      payBasis: payBasis,
      paidWeeks: paidWeeks,
      grossAnnual: grossAnnual,
      takeHomeAnnual: takeHomeAnnual,
      takeHomeRate: takeHomeRate,
      benefitsAnnual: boundedValue(form, 'benefits_monthly', 0, Infinity) * 12,
      childcareMonthly: childcareMonthly,
      careSetupAnnual: boundedValue(form, 'care_setup_annual', 0, Infinity),
      careOvertimeMonthly: boundedValue(form, 'care_overtime_monthly', 0, Infinity),
      backupCareMonthly: boundedValue(form, 'backup_care_monthly', 0, Infinity),
      yourCareShare: boundedValue(form, 'your_care_share', 0, 100) / 100,
      onsiteDays: onsiteDays,
      commuteDaily: boundedValue(form, 'commute_daily', 0, Infinity),
      commuteFixedAnnual: boundedValue(form, 'commute_fixed_monthly', 0, Infinity) * 12,
      commuteHours: boundedValue(form, 'commute_hours', 0, 12),
      timeValue: boundedValue(form, 'time_value', 0, Infinity),
      workCostsAnnual: boundedValue(form, 'work_costs_monthly', 0, Infinity) * 12,
      fsaContribution: boundedValue(form, 'fsa_contribution', 0, Infinity),
      fsaEligibleCost: boundedValue(form, 'fsa_eligible_cost', 0, Infinity),
      fsaPlanLimit: boundedValue(form, 'fsa_plan_limit', 0, Infinity),
      fsaRate: boundedValue(form, 'fsa_rate', 0, 60) / 100,
      optionCare: optionalBoundedValue(form, 'option_care', 0, Infinity, childcareMonthly),
      optionDays: optionalBoundedValue(form, 'option_days', 0, 7, onsiteDays),
      stressBackup: boundedValue(form, 'stress_backup', 0, Infinity)
    };
  }

  function allInCareAnnual(baseCareMonthly, inputs, extraAnnual) {
    return baseCareMonthly * 12
      + inputs.careSetupAnnual
      + inputs.careOvertimeMonthly * 12
      + inputs.backupCareMonthly * 12
      + (extraAnnual || 0);
  }

  function fsaSavingsAnnual(careAnnual, inputs) {
    var modeledElection = Math.min(
      inputs.fsaContribution,
      inputs.fsaEligibleCost,
      inputs.fsaPlanLimit,
      careAnnual
    );
    return Math.max(0, modeledElection) * inputs.fsaRate;
  }

  function commuteCashAnnual(onsiteDays, inputs) {
    return onsiteDays * inputs.paidWeeks * inputs.commuteDaily + inputs.commuteFixedAnnual;
  }

  function commuteHoursAnnual(onsiteDays, inputs) {
    return onsiteDays * inputs.paidWeeks * inputs.commuteHours;
  }

  function evaluateScenario(baseCareMonthly, onsiteDays, extraAnnualCare, inputs) {
    var takeHomeAnnual = inputs.takeHomeAnnual;
    var careAnnual = allInCareAnnual(baseCareMonthly, inputs, extraAnnualCare);
    var personalCareAnnual = careAnnual * inputs.yourCareShare;
    var fsaSavings = fsaSavingsAnnual(careAnnual, inputs);
    var commuteCash = commuteCashAnnual(onsiteDays, inputs);
    var commuteTime = commuteHoursAnnual(onsiteDays, inputs);
    var householdCash = takeHomeAnnual + fsaSavings - careAnnual - commuteCash - inputs.workCostsAnnual;
    var personalCash = takeHomeAnnual + fsaSavings - personalCareAnnual - commuteCash - inputs.workCostsAnnual;
    var householdWithBenefits = householdCash + inputs.benefitsAnnual;
    var timeCost = commuteTime * inputs.timeValue;

    return {
      takeHomeAnnual: takeHomeAnnual,
      careAnnual: careAnnual,
      personalCareAnnual: personalCareAnnual,
      fsaSavingsAnnual: fsaSavings,
      commuteCashAnnual: commuteCash,
      commuteHoursAnnual: commuteTime,
      timeCostAnnual: timeCost,
      householdCashAnnual: householdCash,
      personalCashAnnual: personalCash,
      householdWithBenefitsAnnual: householdWithBenefits,
      timeAdjustedAnnual: householdWithBenefits - timeCost
    };
  }

  function breakEvenCareAnnual(inputs) {
    var takeHomeAnnual = inputs.takeHomeAnnual;
    var fixedCosts = commuteCashAnnual(inputs.onsiteDays, inputs) + inputs.workCostsAnnual;

    function cashAtCare(careAnnual) {
      return takeHomeAnnual + fsaSavingsAnnual(careAnnual, inputs) - careAnnual - fixedCosts;
    }

    if (cashAtCare(0) <= 0) return 0;

    var low = 0;
    var high = 12000;
    while (cashAtCare(high) > 0 && high < 100000000) high *= 2;

    for (var iteration = 0; iteration < 80; iteration += 1) {
      var midpoint = (low + high) / 2;
      if (cashAtCare(midpoint) > 0) {
        low = midpoint;
      } else {
        high = midpoint;
      }
    }
    return (low + high) / 2;
  }

  function updateScenarioRow(form, name, scenario, onsiteDays) {
    var row = form.querySelector('[data-scenario-row="' + name + '"]');
    if (!row) return;
    row.querySelector('[data-scenario="care"]').textContent = money(scenario.careAnnual / 12);
    row.querySelector('[data-scenario="days"]').textContent = new Intl.NumberFormat('en-US', { maximumFractionDigits: 1 }).format(onsiteDays);
    row.querySelector('[data-scenario="household"]').textContent = money(scenario.householdCashAnnual / 12);
    row.querySelector('[data-scenario="personal"]').textContent = money(scenario.personalCashAnnual / 12);
    row.querySelector('[data-scenario="benefits"]').textContent = money(scenario.householdWithBenefitsAnnual / 12);
    row.querySelector('[data-scenario="time"]').textContent = money(scenario.timeAdjustedAnnual / 12);
  }

  function updateActions(form, inputs, current, option, stress) {
    var careShareOfTakeHome = current.takeHomeAnnual > 0 ? current.careAnnual / current.takeHomeAnnual * 100 : 0;
    var monthlyCommuteHours = current.commuteHoursAnnual / 12;
    var monthlyCommuteCash = current.commuteCashAnnual / 12;
    var monthlyHouseholdCash = current.householdCashAnnual / 12;
    var careExtrasAnnual = inputs.careSetupAnnual + inputs.careOvertimeMonthly * 12 + inputs.backupCareMonthly * 12;
    var visibility = {
      verify: true,
      care: careShareOfTakeHome >= 35 || careExtrasAnnual > 0,
      fsa: current.fsaSavingsAnnual > 0,
      flex: option.householdCashAnnual - current.householdCashAnnual >= 600 || monthlyCommuteCash >= 150 || monthlyCommuteHours >= 10,
      benefits: inputs.benefitsAnnual > 0 && (monthlyHouseholdCash < 1000 || inputs.benefitsAnnual / 12 >= 300),
      bonus: boundedValue(form, 'annual_bonus', 0, Infinity) > 0,
      buffer: monthlyHouseholdCash < 1000 || stress.householdCashAnnual < 0,
      backup: inputs.backupCareMonthly === 0 || stress.householdCashAnnual < 0
    };

    form.querySelectorAll('[data-action]').forEach(function (item) {
      item.hidden = !visibility[item.dataset.action];
    });

    var variables = [
      { label: form.dataset.largestCare, amount: current.careAnnual / 12 },
      { label: form.dataset.largestCommute, amount: current.commuteCashAnnual / 12 },
      { label: form.dataset.largestWork, amount: inputs.workCostsAnnual / 12 },
      { label: form.dataset.largestTime, amount: current.timeCostAnnual / 12 }
    ];
    variables.sort(function (a, b) { return b.amount - a.amount; });
    var largest = variables[0];
    var largestText = form.dataset.largestTemplate
      .replace('[label]', largest.label)
      .replace('[amount]', money(largest.amount));
    var largestNode = form.querySelector('[data-largest-variable]');
    if (largestNode) largestNode.textContent = largestText;
  }

  function updateInsights(form, current, option, stress) {
    var currentMonthly = current.householdCashAnnual / 12;
    var optionMonthly = option.householdCashAnnual / 12;
    var stressMonthly = stress.householdCashAnnual / 12;
    var stressNode = form.querySelector('[data-insight="stress"]');
    var optionNode = form.querySelector('[data-insight="option"]');
    var contextNode = form.querySelector('[data-insight="context"]');

    if (stressNode) {
      var stressTemplate = currentMonthly >= 0 && stressMonthly < 0
        ? form.dataset.insightStressCrosses
        : form.dataset.insightStressChange;
      stressNode.textContent = replaceTokens(stressTemplate, {
        current: money(currentMonthly),
        stress: money(stressMonthly),
        difference: money(Math.abs(currentMonthly - stressMonthly))
      });
    }

    if (optionNode) {
      var optionDifference = optionMonthly - currentMonthly;
      var optionTemplate = form.dataset.insightOptionSimilar;
      if (optionDifference > 50) optionTemplate = form.dataset.insightOptionBetter;
      if (optionDifference < -50) optionTemplate = form.dataset.insightOptionWorse;
      optionNode.textContent = replaceTokens(optionTemplate, {
        difference: money(Math.abs(optionDifference))
      });
    }

    if (contextNode) {
      var contextTemplate = form.dataset.insightCommute;
      if (current.householdCashAnnual < 0 && current.householdWithBenefitsAnnual >= 0) {
        contextTemplate = form.dataset.insightBenefitsFlip;
      } else if (current.householdWithBenefitsAnnual >= 0 && current.timeAdjustedAnnual < 0) {
        contextTemplate = form.dataset.insightTimeFlip;
      }
      contextNode.textContent = replaceTokens(contextTemplate, {
        hours: hours(current.commuteHoursAnnual / 12),
        cash: money(current.commuteCashAnnual / 12)
      });
    }
  }

  function updateCalculator(form) {
    var inputs = getInputs(form);
    var current = evaluateScenario(inputs.childcareMonthly, inputs.onsiteDays, 0, inputs);
    var option = evaluateScenario(inputs.optionCare, inputs.optionDays, 0, inputs);
    var stressCare = inputs.childcareMonthly * 1.1;
    var stress = evaluateScenario(stressCare, inputs.onsiteDays, inputs.stressBackup, inputs);
    var breakEvenAnnual = breakEvenCareAnnual(inputs);
    var breakEvenMonthly = breakEvenAnnual / 12;
    var currentCareMonthly = current.careAnnual / 12;
    var breakEvenCushion = breakEvenMonthly - currentCareMonthly;
    var careShareOfTakeHome = current.takeHomeAnnual > 0 ? current.careAnnual / current.takeHomeAnnual * 100 : 0;

    setResult(form, 'household-monthly-cash', money(current.householdCashAnnual / 12));
    setResult(form, 'personal-monthly-cash', money(current.personalCashAnnual / 12));
    setResult(form, 'household-annual-cash', money(current.householdCashAnnual));
    setResult(form, 'monthly-net', money(current.householdWithBenefitsAnnual / 12));
    setResult(form, 'time-adjusted', money(current.timeAdjustedAnnual / 12));
    setResult(form, 'break-even', breakEvenAnnual > 0 ? money(breakEvenMonthly) : form.dataset.notApplicable);
    setResult(form, 'stress-monthly-cash', money(stress.householdCashAnnual / 12));
    setResult(form, 'gross-annual', inputs.payBasis === 'monthly' ? form.dataset.notApplicable : money(inputs.grossAnnual));
    setResult(form, 'take-home', money(current.takeHomeAnnual / 12));
    setResult(form, 'all-in-care', money(currentCareMonthly));
    setResult(form, 'your-care', money(current.personalCareAnnual / 12));
    setResult(form, 'care-share', percentage(careShareOfTakeHome));
    setResult(form, 'commute-cash', money(current.commuteCashAnnual / 12));
    setResult(form, 'commute-time', hours(current.commuteHoursAnnual / 12));
    setResult(form, 'fsa-savings', money(current.fsaSavingsAnnual));
    setResult(form, 'break-even-cushion', breakEvenAnnual > 0 ? money(breakEvenCushion) : form.dataset.notApplicable);

    updateScenarioRow(form, 'option', option, inputs.optionDays);
    updateScenarioRow(form, 'current', current, inputs.onsiteDays);
    updateScenarioRow(form, 'stress', stress, inputs.onsiteDays);
    updateActions(form, inputs, current, option, stress);
    updateInsights(form, current, option, stress);

    var message = form.querySelector('[data-result="message"]');
    var resultCard = form.querySelector('[data-result-card]');
    var resultBand = 'negative';
    if (current.householdCashAnnual / 12 > 1000) {
      message.textContent = message.dataset.positive;
      resultCard.dataset.tone = 'positive';
      resultBand = 'positive';
    } else if (current.householdCashAnnual >= 0) {
      message.textContent = message.dataset.neutral;
      resultCard.dataset.tone = 'neutral';
      resultBand = 'neutral';
    } else {
      message.textContent = message.dataset.negative;
      resultCard.dataset.tone = 'negative';
    }
    form.dataset.resultBand = resultBand;
    return {
      payBasis: inputs.payBasis,
      resultBand: resultBand,
      current: current,
      breakEvenMonthly: breakEvenMonthly
    };
  }

  function copySummary(form) {
    var resultNames = [
      'household-monthly-cash',
      'personal-monthly-cash',
      'household-annual-cash',
      'monthly-net',
      'time-adjusted',
      'break-even',
      'stress-monthly-cash'
    ];
    var lines = [form.dataset.copyTitle];
    resultNames.forEach(function (name) {
      var result = form.querySelector('[data-result="' + name + '"]');
      if (!result) return;
      var wrapper = result.parentElement;
      var label = wrapper ? wrapper.querySelector('span') : null;
      lines.push((label ? label.textContent.trim() : name) + ': ' + result.textContent.trim());
    });
    var text = lines.join('\n');
    var status = form.querySelector('[data-copy-status]');

    function markCopied(success) {
      if (status) status.textContent = success ? form.dataset.copySuccess : form.dataset.copyFailure;
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function () {
        markCopied(true);
      }).catch(function () {
        markCopied(false);
      });
      return;
    }

    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      markCopied(document.execCommand('copy'));
    } catch (error) {
      markCopied(false);
    }
    textarea.remove();
  }

  var planSchema = 'morrow-mama-return-to-work-plan';
  var planFormatVersion = 2;
  var planLifetimeMilliseconds = 90 * 24 * 60 * 60 * 1000;
  var planMaximumFileBytes = 65536;
  var planBlankFieldNames = [
    'take_home_monthly',
    'annual_salary',
    'hourly_rate',
    'hours_week',
    'option_care',
    'option_days'
  ];
  var planFieldNames = [
    'pay_basis',
    'take_home_monthly',
    'annual_salary',
    'hourly_rate',
    'hours_week',
    'paid_weeks',
    'annual_bonus',
    'take_home_percent',
    'benefits_monthly',
    'childcare_monthly',
    'care_setup_annual',
    'care_overtime_monthly',
    'backup_care_monthly',
    'your_care_share',
    'onsite_days',
    'commute_daily',
    'commute_fixed_monthly',
    'commute_hours',
    'time_value',
    'work_costs_monthly',
    'fsa_contribution',
    'fsa_eligible_cost',
    'fsa_plan_limit',
    'fsa_rate',
    'option_care',
    'option_days',
    'stress_backup'
  ];

  function planDate(value) {
    var date = new Date(value);
    if (!Number.isFinite(date.getTime())) return '';
    return new Intl.DateTimeFormat('en-US', {
      dateStyle: 'medium',
      timeStyle: 'short'
    }).format(date);
  }

  function setPlanStatus(form, messageName, replacements, tone) {
    var status = form.querySelector('[data-mm-plan-status]');
    if (!status) return;
    var message = form.dataset[messageName] || '';
    Object.keys(replacements || {}).forEach(function (key) {
      message = message.replace('[' + key + ']', replacements[key]);
    });
    status.textContent = message;
    status.dataset.tone = tone || 'neutral';
  }

  function planStorage(form) {
    try {
      var storage = window.localStorage;
      if (!storage || !form.dataset.planStorageKey) return null;
      return storage;
    } catch (error) {
      return null;
    }
  }

  function normalizedFieldValue(field) {
    if (!field) return null;
    if (field.name === 'pay_basis') {
      if (field.value === 'monthly' || field.value === 'hourly') return field.value;
      return 'salary';
    }
    if (planBlankFieldNames.indexOf(field.name) !== -1 && String(field.value).trim() === '') return '';
    var value = Number(field.value);
    if (!Number.isFinite(value)) value = 0;
    var minimum = field.hasAttribute('min') ? Number(field.getAttribute('min')) : -Infinity;
    var maximum = field.hasAttribute('max') ? Number(field.getAttribute('max')) : Infinity;
    if (Number.isFinite(minimum)) value = Math.max(minimum, value);
    if (Number.isFinite(maximum)) value = Math.min(maximum, value);
    return String(value);
  }

  function createPlan(form) {
    var savedAt = new Date();
    var inputs = {};
    planFieldNames.forEach(function (name) {
      inputs[name] = normalizedFieldValue(form.elements[name]);
    });
    return {
      schema: planSchema,
      formatVersion: planFormatVersion,
      calculatorVersion: form.dataset.calculatorVersion || '3.0',
      savedAt: savedAt.toISOString(),
      expiresAt: new Date(savedAt.getTime() + planLifetimeMilliseconds).toISOString(),
      inputs: inputs
    };
  }

  function validatePlan(form, candidate) {
    if (!candidate || typeof candidate !== 'object') return { error: 'invalid' };
    if (candidate.schema !== planSchema || (candidate.formatVersion !== 1 && candidate.formatVersion !== planFormatVersion)) return { error: 'invalid' };
    if (!candidate.inputs || typeof candidate.inputs !== 'object') return { error: 'invalid' };

    var savedAt = Date.parse(candidate.savedAt);
    var expiresAt = Date.parse(candidate.expiresAt);
    if (!Number.isFinite(savedAt) || !Number.isFinite(expiresAt) || expiresAt <= savedAt) return { error: 'invalid' };
    if (savedAt > Date.now() + 300000 || expiresAt - savedAt > planLifetimeMilliseconds + 1000) return { error: 'invalid' };
    if (Date.now() > expiresAt) return { error: 'expired' };

    var values = {};
    for (var index = 0; index < planFieldNames.length; index += 1) {
      var name = planFieldNames[index];
      var field = form.elements[name];
      var hasValue = Object.prototype.hasOwnProperty.call(candidate.inputs, name);
      if (!field) {
        if (name === 'take_home_monthly' && candidate.formatVersion === 1) continue;
        return { error: 'invalid' };
      }
      if (!hasValue) {
        if (name === 'take_home_monthly' && candidate.formatVersion === 1) {
          values[name] = '';
          continue;
        }
        return { error: 'invalid' };
      }
      if (name === 'pay_basis') {
        var payBasis = candidate.inputs[name];
        if (payBasis !== 'monthly' && payBasis !== 'salary' && payBasis !== 'hourly') return { error: 'invalid' };
        if (candidate.formatVersion === 1 && payBasis === 'monthly') return { error: 'invalid' };
        values[name] = candidate.inputs[name];
        continue;
      }

      if (planBlankFieldNames.indexOf(name) !== -1 && candidate.inputs[name] === '') {
        values[name] = '';
        continue;
      }

      var value = Number(candidate.inputs[name]);
      if (!Number.isFinite(value)) return { error: 'invalid' };
      var minimum = field.hasAttribute('min') ? Number(field.getAttribute('min')) : -Infinity;
      var maximum = field.hasAttribute('max') ? Number(field.getAttribute('max')) : Infinity;
      if (Number.isFinite(minimum) && value < minimum) return { error: 'invalid' };
      if (Number.isFinite(maximum) && value > maximum) return { error: 'invalid' };
      values[name] = String(value);
    }

    return {
      plan: candidate,
      values: values
    };
  }

  function applyPlan(form, validatedPlan) {
    planFieldNames.forEach(function (name) {
      if (form.elements[name] && Object.prototype.hasOwnProperty.call(validatedPlan.values, name)) {
        form.elements[name].value = validatedPlan.values[name];
      }
    });
    syncPayMode(form);
    updateCalculator(form);
    setCalculatorState(form, true);
  }

  function savePlanOnDevice(form) {
    if (!form.reportValidity()) return;
    var storage = planStorage(form);
    if (!storage) {
      setPlanStatus(form, 'planStorageUnavailable', {}, 'error');
      return;
    }
    var plan = createPlan(form);
    try {
      storage.setItem(form.dataset.planStorageKey, JSON.stringify(plan));
      setPlanStatus(form, 'planSaveSuccess', {
        date: planDate(plan.savedAt),
        expires: planDate(plan.expiresAt)
      }, 'success');
    } catch (error) {
      setPlanStatus(form, 'planStorageUnavailable', {}, 'error');
    }
  }

  function loadPlanFromDevice(form) {
    var storage = planStorage(form);
    if (!storage) {
      setPlanStatus(form, 'planStorageUnavailable', {}, 'error');
      return;
    }
    var serialized;
    try {
      serialized = storage.getItem(form.dataset.planStorageKey);
    } catch (error) {
      setPlanStatus(form, 'planStorageUnavailable', {}, 'error');
      return;
    }
    if (!serialized) {
      setPlanStatus(form, 'planNone', {}, 'neutral');
      return;
    }

    var candidate;
    try {
      candidate = JSON.parse(serialized);
    } catch (error) {
      setPlanStatus(form, 'planInvalid', {}, 'error');
      return;
    }
    var validated = validatePlan(form, candidate);
    if (validated.error === 'expired') {
      try {
        storage.removeItem(form.dataset.planStorageKey);
      } catch (error) {
      }
      setPlanStatus(form, 'planExpired', {}, 'neutral');
      return;
    }
    if (validated.error) {
      setPlanStatus(form, 'planInvalid', {}, 'error');
      return;
    }

    applyPlan(form, validated);
    setPlanStatus(form, 'planLoadSuccess', {
      date: planDate(validated.plan.savedAt),
      expires: planDate(validated.plan.expiresAt)
    }, 'success');
  }

  function deletePlanFromDevice(form) {
    var storage = planStorage(form);
    if (!storage) {
      setPlanStatus(form, 'planStorageUnavailable', {}, 'error');
      return;
    }
    try {
      storage.removeItem(form.dataset.planStorageKey);
      setPlanStatus(form, 'planDeleteSuccess', {}, 'success');
    } catch (error) {
      setPlanStatus(form, 'planStorageUnavailable', {}, 'error');
    }
  }

  function exportPlan(form) {
    if (!form.reportValidity()) return;
    var plan = createPlan(form);
    try {
      var blob = new Blob([JSON.stringify(plan, null, 2)], { type: 'application/json' });
      var objectUrl = window.URL.createObjectURL(blob);
      var download = document.createElement('a');
      download.href = objectUrl;
      download.download = 'morrow-mama-return-to-work-plan-' + plan.savedAt.slice(0, 10) + '.json';
      document.body.appendChild(download);
      download.click();
      download.remove();
      window.setTimeout(function () { window.URL.revokeObjectURL(objectUrl); }, 0);
      setPlanStatus(form, 'planExportSuccess', { date: planDate(plan.savedAt) }, 'success');
    } catch (error) {
      setPlanStatus(form, 'planFileError', {}, 'error');
    }
  }

  function importPlan(form, file) {
    if (!file) return;
    if (file.size > planMaximumFileBytes) {
      setPlanStatus(form, 'planTooLarge', {}, 'error');
      return;
    }
    var reader = new FileReader();
    reader.addEventListener('load', function () {
      var candidate;
      try {
        candidate = JSON.parse(String(reader.result));
      } catch (error) {
        setPlanStatus(form, 'planInvalid', {}, 'error');
        return;
      }
      var validated = validatePlan(form, candidate);
      if (validated.error === 'expired') {
        setPlanStatus(form, 'planExpired', {}, 'neutral');
        return;
      }
      if (validated.error) {
        setPlanStatus(form, 'planInvalid', {}, 'error');
        return;
      }
      applyPlan(form, validated);
      setPlanStatus(form, 'planImportSuccess', {
        date: planDate(validated.plan.savedAt),
        expires: planDate(validated.plan.expiresAt)
      }, 'success');
    });
    reader.addEventListener('error', function () {
      setPlanStatus(form, 'planFileError', {}, 'error');
    });
    reader.readAsText(file);
  }

  function initializeCalculator(form) {
    if (!form || form.hasAttribute('data-mm-calculator-initialized')) return;
    form.setAttribute('data-mm-calculator-initialized', 'true');
    syncPayMode(form);

    function markStarted() {
      publishCalculatorEventOnce(form, 'calculator_start');
    }

    function refreshCalculatedResult() {
      if (form.dataset.calculated !== 'true') return;
      if (form.checkValidity()) updateCalculator(form);
      else setCalculatorState(form, false);
    }

    form.addEventListener('input', function (event) {
      if (event.target.matches('[data-pay-basis]')) syncPayMode(form);
      if (event.target.closest('.mm-calc-quick')) markStarted();
      refreshCalculatedResult();
    });
    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-pay-basis]')) syncPayMode(form);
      if (event.target.closest('.mm-calc-quick')) markStarted();
      refreshCalculatedResult();
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) {
        var invalidField = form.querySelector(':invalid');
        var advancedContainer = invalidField && invalidField.closest('[data-mm-calculator-advanced]');
        if (advancedContainer) advancedContainer.open = true;
        return;
      }
      var firstCalculation = form.dataset.calculated !== 'true';
      var calculation = updateCalculator(form);
      setCalculatorState(form, true);
      markStarted();
      publishCalculatorEventOnce(form, 'quick_snapshot_complete', {
        result_band: calculation.resultBand
      });
      if (firstCalculation) {
        var primaryResults = form.querySelector('[data-calculator-primary-results]');
        if (primaryResults) {
          window.setTimeout(function () {
            primaryResults.focus({ preventScroll: true });
            if (window.matchMedia('(max-width: 960px)').matches) {
              primaryResults.scrollIntoView({
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                block: 'start'
              });
            }
          }, 0);
        }
      }
    });
    form.addEventListener('reset', function () {
      window.setTimeout(function () {
        syncPayMode(form);
        setCalculatorState(form, false);
        delete form.dataset.resultBand;
        form.querySelectorAll(
          '[data-mm-calculator-advanced], .mm-calc-result-details, .mm-calc-deep-results'
        ).forEach(function (details) {
          details.open = false;
        });
      }, 0);
    });

    var advanced = form.querySelector('[data-mm-calculator-advanced]');
    if (advanced) {
      advanced.addEventListener('toggle', function () {
        if (!advanced.open) return;
        form.setAttribute('data-advanced-opened', 'true');
        publishCalculatorEventOnce(form, 'advanced_opened');
      });
    }

    var openAdvancedButton = form.querySelector('[data-mm-open-advanced]');
    if (openAdvancedButton && advanced) {
      openAdvancedButton.addEventListener('click', function () {
        advanced.open = true;
        form.setAttribute('data-advanced-opened', 'true');
        publishCalculatorEventOnce(form, 'advanced_opened');
        var summary = advanced.querySelector('summary');
        if (summary) {
          summary.focus({ preventScroll: true });
          summary.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      });
    }

    document.querySelectorAll('[data-mm-calculator-start-link]').forEach(function (link) {
      if (link.getAttribute('href') !== '#' + form.id) return;
      link.addEventListener('click', markStarted);
    });

    form.querySelectorAll('[data-mm-toolkit-cta]').forEach(function (link) {
      link.addEventListener('click', function () {
        publishCalculatorEventOnce(form, 'toolkit_cta_click', {
          result_band: form.dataset.resultBand || 'not_calculated'
        });
      });
    });

    var copyButton = form.querySelector('[data-mm-copy]');
    if (copyButton) copyButton.addEventListener('click', function () { copySummary(form); });
    var printButton = form.querySelector('[data-mm-print]');
    if (printButton) printButton.addEventListener('click', function () { window.print(); });
    var savePlanButton = form.querySelector('[data-mm-plan-save]');
    if (savePlanButton) savePlanButton.addEventListener('click', function () { savePlanOnDevice(form); });
    var loadPlanButton = form.querySelector('[data-mm-plan-load]');
    if (loadPlanButton) loadPlanButton.addEventListener('click', function () { loadPlanFromDevice(form); });
    var deletePlanButton = form.querySelector('[data-mm-plan-delete]');
    if (deletePlanButton) deletePlanButton.addEventListener('click', function () { deletePlanFromDevice(form); });
    var exportPlanButton = form.querySelector('[data-mm-plan-export]');
    if (exportPlanButton) exportPlanButton.addEventListener('click', function () { exportPlan(form); });
    var importPlanButton = form.querySelector('[data-mm-plan-import-button]');
    var importPlanInput = form.querySelector('[data-mm-plan-import-file]');
    if (importPlanButton && importPlanInput) {
      importPlanButton.addEventListener('click', function () { importPlanInput.click(); });
      importPlanInput.addEventListener('change', function () {
        importPlan(form, importPlanInput.files && importPlanInput.files[0]);
        importPlanInput.value = '';
      });
    }
    setCalculatorState(form, false);
  }

  document.querySelectorAll('[data-mm-calculator]').forEach(initializeCalculator);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches('[data-mm-calculator]')) initializeCalculator(event.target);
    event.target.querySelectorAll('[data-mm-calculator]').forEach(initializeCalculator);
  });

  document.querySelectorAll('.mm-mobile-menu nav a').forEach(function (link) {
    link.addEventListener('click', function () {
      var details = link.closest('details');
      if (details) details.removeAttribute('open');
    });
  });
})();
